import { render, staticRenderFns } from "./productPrice.vue?vue&type=template&id=1e2c8c52&scoped=true&"
import script from "./productPrice.vue?vue&type=script&lang=js&"
export * from "./productPrice.vue?vue&type=script&lang=js&"
import style0 from "./productPrice.vue?vue&type=style&index=0&id=1e2c8c52&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2c8c52",
  null
  
)

export default component.exports